// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_pnpm_auth0_auth0-react_1_12_0_react-dom_18_2_0_react_18_1_0__react_18_1_-e99a2d"], () => (__webpack_require__("./src/index.tsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
